import axios from 'axios';

const project_url = 'projects/';

export default {
    async updateProject(id, project){
        const url = project_url + `${id}/`;
        return axios.patch(url, project)
        .then((response) => {
            return response.data
        }).catch(err => {
            console.log(err.response.data);
        });
    }
}